import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import Cli from '@/components/modules/act/Cli'
import CliTabs from '@/components/modules/act/CliTabs'
import Subscription from '@/components/modules/subscriptions/Subscription'
import SubscriptionTabs from '@/components/modules/subscriptions/SubscriptionTabs'
import TelephonePricelistEdit from '@/components/modules/subscriptions/TelephonePricelistEdit'
import SubscriptionsSettings from '@/components/modules/subscriptions/settings/SubscriptionsSettings'
import SubscriptionStatistics from '@/components/modules/subscriptions/SubscriptionStatistics'

export const subscriptions = [
	{
		path: '/subscriptions',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/subscriptions/',
					text: 'Abbonamenti',
				},
				{
					to: '/subscriptions/statistics/',
					text: 'Statistiche',
				},
				{
					to: '/subscriptions/telephone_pricelists/',
					text: 'Listini Telefonici',
					module: 'act'
				},
				{
					to: '/subscriptions/clis/',
					text: 'CLI Telefonici',
					module: 'act'
				},
			],
		},
		children: [
			{
				path: '/subscriptions/',
				name: 'subscriptions-index',
				meta: {
					title: trans('subscriptions')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'subscriptions',
					actionIcon: 'payments',
					title: 'Abbonamenti',
					styleClass: 'mb-offset',
				}
			},
			{
				path: '/subscriptions/statistics/',
				name: 'subscriptions-global-statistics',
				meta: {
					title: 'Statistiche Globali Abbonamenti'
				},
				beforeEnter: ifAuthenticated,
				component: SubscriptionStatistics,
				props: {
					// No id prop needed for global statistics
				}
			},
			{
				path: '/subscriptions/telephone_pricelists',
				name: 'telephone_pricelists-index',
				meta: {
					title: trans('telephone_pricelists')
				},				
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'telephone_pricelists',
					actionIcon: 'mdi-currency-eur',
					title: 'Listini Telefonici',
					styleClass: 'mb-offset',
				}
			},
			{
				path: '/subscriptions/clis',
				name: 'clis-index',
				meta: {
					title: 'CLI'
				},				
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'clis',
					actionIcon: 'mdi-phone-incoming-outgoing',
					title: 'CLI',
					styleClass: 'mb-offset',
				}
			},
		],
	},
	{ 
		path: '/subscriptions/create',
		name: 'subscriptions-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'subscriptions',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect,
			footerComponent: 'footer-product-document-table'
		}),	
	},
	{ 
		path: '/subscriptions/:id/edit',
		name: 'subscriptions-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'subscriptions',
			id: parseInt(route.params.id),
			footerComponent: 'footer-product-document-table'
		}),
	}, 
	{ 
		path: '/subscriptions/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: SubscriptionTabs,
		props: (route) => ({
			id: parseInt(route.params.id),
		}), 
		children: [
			{
				path: '',
				name: 'subscriptions-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Subscription,
				meta: {
					title: 'Abbonamento',
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
				}), 
			},
			{
				path: '/subscriptions/:id/statistics',
				name: 'subscriptions-statistics',
				beforeEnter: ifAuthenticatedOnline,
				component: SubscriptionStatistics,
				meta: {
					title: 'Statistiche Abbonamento',
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				}), 
			},
			{
				path: '/subscriptions/:id/clis',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'act', next) },
				beforeEnter: ifAuthenticatedOnline,
				component: Crud, 
				meta: {
					title: 'CLI Telefonici',
				},
				props: (route) => ({
					modelDef: 'clis',
					actionIcon: 'phone',
					title: 'CLI Telefonici',
					styleClass: 'mb-offset',
					subFilters: {subscriptions: parseInt(route.params.id)},
					defaultInput: {subscription_id: parseInt(route.params.id)},
				}), 
			},
			{
				path: '/subscriptions/:id/ddts',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'timecards', next) },
				component: Crud,
				meta: {
					title: 'DDT associati'
				},
				props: (route) => ({
					modelDef: 'ddts',
					actionIcon: 'description',
					title: 'DDT associati',
					styleClass: 'mb-offset',
					subFilters: {subscriptions: parseInt(route.params.id)},
				})
			},			
		]
	},
	{
		path: '/subscriptions/clis/create',
		name: 'clis-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'clis',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/subscriptions/clis/:id/edit',
		name: 'clis-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'clis',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/subscriptions/clis/:id',
		beforeEnter: ifAuthenticated,
		component: CliTabs, 
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'clis-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Cli,
				meta: {
					title: 'Cli'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
				}),
			},		
		]
	},
	{ 
		path: '/subscriptions/telephone_pricelists/create',
		name: 'telephone_pricelists-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'telephone_pricelists',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect,
		}),	
	},
	{ 
		path: '/subscriptions/telephone_pricelists/:id/edit',
		name: 'telephone_pricelists-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: TelephonePricelistEdit,
		props: (route) => ({
			modelDef:  'telephone_pricelists',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/subscriptions/telephone_pricelists/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/subscriptions/telephone_pricelists/' + parseInt(route.params.id) + '/',
					text: 'Listino Telefonico',
				},
			],
		}),		
		children: [
			{
				path: '',
				name: 'telephone_pricelists-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Listino Telefonico'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'telephone_pricelists',
					modelClass: 'telephonepricelist',
					activities: true,
					fileuploader: true,
				}),
			},		
		]
	},
	{ 
		path: '/settingssubscriptions/',
		name: 'settingssubscriptions',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingssubscriptions',
					text: 'Abbonamenti',
				},
			],
		},
		children: [
			{
				path: '/settingssubscriptions/',
				beforeEnter: ifAuthenticatedOnline,
				component: SubscriptionsSettings,
			},
		],
	},	
]